// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"5bd2730d","891":"0e681ded"}[chunkId] + ".chunk.css";
};